import { useCallback, useEffect, useRef, useState } from "react";
import { useHistory } from "react-router";
import { Modal, Button, Form, Container, Row, Col } from "react-bootstrap";

// Components
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";

// actions
import * as enablementAction from "../../actions/partnerPortal/enablement/EnablementAction";

// Scss
import "../../assets/css/partnerPortal/appDeveloper.scss";
import "../../assets/css/partnerPortal/salesEnablement.scss";
import "../../assets/css/partnerPortal/sales.scss";
import "../../assets/css/partnerPortal/welcome.scss";
import "../../assets/css/partnerPortal/calendar.scss";

import { ButtonGroup, ToggleButton } from "react-bootstrap";
import SubscriptionRequestDTO from "../../models/SubscriptionRequestDTO";
import UnsubscriptionRequestDTO from "../../models/UnsubscriptionRequestDTO";
import EventCLusterDTO from "../../models/EventClusterDTO";

moment.locale("en-GB");
const localizer = momentLocalizer(moment);

function CalendarBlock() {
  let history = useHistory();

  const [show, setShow] = useState(false);
  const [showUns, setShowUns] = useState(false);
  const handleClose = () => closeForm();

  const [hasSubmitted, setHasSubmitted] = useState(false);
  const [apiResponse, setApiResponse] = useState(<span></span>);
  let [eventsData, setEventsData] = useState(
    Array<{ title; start; end; link; region; type }>()
  );
  const [eventsDataAll, setEventsDataAll] = useState(
    Array<{ title; start; end; link; region; type }>()
  );
  const [buttonChecked, setButtonChecked] = useState("all");

  const [form, setForm] = useState({
    email: "",
    name: "",
    REGIONS: [],
    TRAINING: [],
  });

  const onNavigate = useCallback(
    (event) => ({
      ...(event.region === "EMEA" && {
        className: "emea-color",
      }),
      ...(event.region === "NORAM" && {
        className: "noram-color",
      }),
      ...(event.region === "LATAM" && {
        className: "latam-color",
      }),
      ...(event.region === "APAC" && {
        className: "apac-color",
      }),
      ...(event.type === "WEBINAR" && {
        className: "live-webinar-color",
      }),
    }),
    []
  );

  useEffect(() => {
    canYouHaveAccess();
    getAllEvents();
  }, []);

  function filterCalendarByType(type: string) {
    setButtonChecked(type);
    if (type === "all") setEventsData(eventsDataAll);
    else {
      const eventsFiltered = eventsDataAll.filter((e) => e.type === type);
      setEventsData(eventsFiltered);
    }
    // setEventsData
  }

  // localStorage from zinfi to input field
  window.addEventListener(
    "message",
    function (event) {
      var origin = event.origin; // For Chrome, the origin property is in the event.originalEvent object.
      if (origin !== "https://partners.dynatrace.com") {
        return;
      }

      if (typeof event.data === "object" && event.data.call === "sendValue") {
        // Do something with event.data.value;
        var userInfo = event.data.value;
        if (origin === "https://partners.dynatrace.com") {
          console.log(userInfo);
          setForm({
            ...form,
            email: userInfo.email,
            name: userInfo.first_name + " " + userInfo.last_name,
          });
        }
      }
    },
    false
  );

  function openCalendarDay(e) {
    window.open(e.link, "_blank");
  }

  return (
    <>
      <Container
        id="calendar"
        className="d-flex flex-column margin96Botton"
        fluid
      >
        <Row className="d-flex flex-column align-items-center mb-5  ">
          <div className="d-flex align-items-center align-self-stretch textStyle colorBlack m-auto">
            Live training calendar
          </div>
        </Row>
        <div className="">
          <div className="introframeSubText justify-content-center">
            Register for an upcoming enablement event by clicking on the
            relevant calendar item.
            <br />
            Find enablement events in your preferred time zone by using the
            color codes below.
          </div>
          <div className="flexToBlockCard align-items-center w-100 mb-5">
            <div className="d-flex align-items-center flex-column width25 grow100">
              <div className="d-flex flex-column align-items-center align-self-stretch justify-content-between m-2">
                <div className="d-flex align-items-start align-self-stretch justify-content-center calendarSubtitles noram-color p-2">
                  Americas (English)
                </div>
              </div>
            </div>
            <div className="d-flex align-items-center flex-column width25 grow100">
              <div className="d-flex flex-column align-items-center align-self-stretch justify-content-between m-2">
                <div className="d-flex align-items-start align-self-stretch justify-content-center calendarSubtitles latam-color p-2">
                  Americas (Spanish)
                </div>
              </div>
            </div>
            <div className="d-flex align-items-center flex-column width25 grow100">
              <div className="d-flex flex-column align-items-center align-self-stretch justify-content-between m-2">
                <div className="d-flex align-items-start align-self-stretch justify-content-center calendarSubtitles emea-color p-2">
                  Europe | Middle East | Africa
                </div>
              </div>
            </div>
            <div className="d-flex align-items-center flex-column width25 grow100">
              <div className="d-flex flex-column align-items-center align-self-stretch justify-content-between m-2">
                <div className="d-flex align-items-start align-self-stretch justify-content-center calendarSubtitles apac-color p-2">
                  Asia | Australasia
                </div>
              </div>
            </div>
          </div>
          {/* <div className="introframeSubText justify-content-center">
                            <b>Filters</b>
                        </div> */}
        </div>
        <Row className="w-100 ">
          <Col className="d-flex justify-content-end">
            <ButtonGroup toggle className="mb-2">
              <ToggleButton
                key="1"
                id="toggle-check"
                value={"Show all"}
                type="radio"
                name="Show all"
                variant="outline-dark"
                checked={buttonChecked === "all"}
                onChange={() => filterCalendarByType("all")}
              >
                Show all
              </ToggleButton>
              <ToggleButton
                key="1"
                id="toggle-check"
                value={"ASSOCIATE"}
                type="radio"
                name="ASSOCIATE"
                variant="outline-dark"
                checked={buttonChecked === "ASSOCIATE"}
                onChange={() => filterCalendarByType("ASSOCIATE")}
              >
                Associate Certification Bootcamp
              </ToggleButton>
              <ToggleButton
                key="1"
                id="toggle-check"
                value={"PROFESSIONAL"}
                type="radio"
                name="PROFESSIONAL"
                variant="outline-dark"
                checked={buttonChecked === "PROFESSIONAL"}
                onChange={() => filterCalendarByType("PROFESSIONAL")}
              >
                Professional Certification Bootcamp
              </ToggleButton>
              <ToggleButton
                key="1"
                id="toggle-check"
                value={"TECHNICAL_SALES"}
                type="radio"
                name="ASSOCIATE"
                variant="outline-dark"
                checked={buttonChecked === "TECHNICAL_SALES"}
                onChange={() => filterCalendarByType("TECHNICAL_SALES")}
              >
                Technical Sales
              </ToggleButton>
              <ToggleButton
                key="1"
                id="toggle-check"
                value={"WEBINAR"}
                type="radio"
                name="WEBINAR"
                variant="outline-dark"
                checked={buttonChecked === "WEBINAR"}
                onChange={() => filterCalendarByType("WEBINAR")}
              >
                Live Webinars
              </ToggleButton>
              <ToggleButton
                key="1"
                id="toggle-check"
                value={"HOT"}
                type="radio"
                name="HOT"
                variant="outline-dark"
                checked={buttonChecked === "HOT"}
                onChange={() => filterCalendarByType("HOT")}
              >
                HOT
              </ToggleButton>
            </ButtonGroup>
          </Col>
        </Row>

        <Row className="w-100 mx-auto">
          <Col>
            <Calendar
              views={["month"]}
              selectable
              localizer={localizer}
              defaultDate={new Date()}
              defaultView="month"
              events={eventsData}
              style={{ height: "100vh", fontFamily: "BerninaSans-reg" }}
              onSelectEvent={openCalendarDay}
              eventPropGetter={onNavigate}
              className="mt-5 w-100"
            />
          </Col>
        </Row>
      </Container>

      <Modal show={showUns} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title className="letterType">
            Enablement notifications
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmitUns}>
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label className="letterType">Email address</Form.Label>
              <Form.Control
                className="letterType"
                name="email"
                type="email"
                placeholder="Enter email"
                value={form.email}
                disabled={
                  form.email !== null &&
                  form.email !== undefined &&
                  form.email?.length > 0
                }
                required={true}
                onChange={onChangeForm}
              />
            </Form.Group>
            <Button onClick={handleSubmitUns} className="letterType">
              Unsubscribe all
            </Button>
            {apiResponse}
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={handleClose}
            className="letterType"
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal className="modalClass" show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title className="letterType">
            Enablement notifications
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            {/* <Form.Group className="mb-3" controlId="formBasicEmail">
                    <Form.Label>Email address</Form.Label>
                    <Form.Control name="email" type="email" placeholder="Enter email" value={form.email} required={true}  onChange={onChangeForm} />
                </Form.Group>
                <Form.Group className="mb-3" controlId="formBasicName">
                    <Form.Label>Name</Form.Label>
                    <Form.Control type="text" name="name" onChange={onChangeForm} value={form.name} placeholder="Enter name" required />
                </Form.Group>  */}
            <Form.Group className="mb-3" controlId="formBasicRegion">
              <Form.Label className="letterType">
                Training regions (time zones) you'd like to get notified about:
              </Form.Label>
              <br />
              <Form.Check
                className="letterType"
                inline
                type="checkbox"
                id="NORAM"
                label="Americas (English)"
                name="REGIONS"
                value="NORAM"
                onChange={onChangeCheckForm}
              />
              <br />
              <Form.Check
                className="letterType"
                inline
                type="checkbox"
                id="LATAM"
                label="Americas (Spanish)"
                value={"LATAM"}
                name="REGIONS"
                onChange={onChangeCheckForm}
              />
              <br />
              <Form.Check
                className="letterType"
                inline
                type="checkbox"
                id="EMEA"
                label="Europe | Middle East | Africa"
                name="REGIONS"
                value="EMEA"
                onChange={onChangeCheckForm}
              />
              <br />
              <Form.Check
                className="letterType"
                inline
                type="checkbox"
                id="APAC"
                label="Asia | Australasia"
                value={"APAC"}
                name="REGIONS"
                onChange={onChangeCheckForm}
              />
              <br></br>
              {(hasSubmitted && !form["REGIONS"]) ||
              (hasSubmitted && form["REGIONS"].length === 0) ? (
                <span className="text-danger font-weight-bold">
                  Please insert one or more regions
                </span>
              ) : (
                ""
              )}
            </Form.Group>
            <Form.Group className="mb-3" controlId="formBasicName">
              <Form.Label className="letterType">
                Training types you'd like to get notified about:
              </Form.Label>
              <Form.Check
                className="letterType"
                inline
                type="checkbox"
                id="ASSOCIATE"
                label="Associate Certification Bootcamp"
                value={"ASSOCIATE"}
                name="TRAINING"
                onChange={onChangeCheckForm}
              />
              <br />
              <Form.Check
                className="letterType"
                inline
                type="checkbox"
                id="PROFESSIONAL"
                label="Professional Certification Bootcamp"
                value={"PROFESSIONAL"}
                name="TRAINING"
                onChange={onChangeCheckForm}
              />
              <br />
              <Form.Check
                className="letterType"
                inline
                type="checkbox"
                id="TECHNICAL_SALES"
                label="Technical Sales Bootcamp"
                value="TECHNICAL_SALES"
                name="TRAINING"
                onChange={onChangeCheckForm}
              />
              <br />
              <Form.Check
                className="letterType"
                inline
                type="checkbox"
                id="WEBINAR"
                label="Tech Update Webinars"
                value={"WEBINAR"}
                name="TRAINING"
                onChange={onChangeCheckForm}
              />
              <br />
              <Form.Check
                className="letterType"
                inline
                type="checkbox"
                id="HOT"
                label="HOT sessions"
                value={"HOT"}
                name="TRAINING"
                onChange={onChangeCheckForm}
              />
              <br />
              <br></br>
              {(hasSubmitted && !form["TRAINING"]) ||
              (hasSubmitted && form["TRAINING"].length === 0) ? (
                <span className="text-danger font-weight-bold">
                  Please insert one or more training events
                </span>
              ) : (
                ""
              )}
            </Form.Group>
            <Button onClick={handleSubmit} className="letterType">
              Subscribe
            </Button>
            {apiResponse}
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={handleClose}
            className="letterType"
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );

  async function handleSubmit(event) {
    const request = new SubscriptionRequestDTO(
      form["name"],
      form["email"],
      form["REGIONS"],
      form["TRAINING"]
    );
    setHasSubmitted(true);
    if (
      !form["REGIONS"] ||
      !form["TRAINING"] ||
      form["REGIONS"].length === 0 ||
      form["TRAINING"].length === 0
    ) {
      console.log("Please fill the region and trainings");
      return;
    }
    setApiResponse(
      <span className="ml-3 text-danger font-weight-bold">{"Waiting..."}</span>
    );
    enablementAction
      .doSubscription(request)
      .then((response) => {
        response.data.isSuccess === true
          ? setApiResponse(
              <span className="ml-3 text-danger font-weight-bold">
                {"Subscription done"}
              </span>
            )
          : setApiResponse(
              <span className="ml-3 text-danger font-weight-bold">
                {"Something went wrong. Try again later."}
              </span>
            );
      })
      .catch((err) => {
        console.error("subscription failed", err);
        setApiResponse(
          <span className="ml-3 text-danger font-weight-bold">
            {"Something went wrong. Try again later."}
          </span>
        );
      });
  }

  async function handleSubmitUns(event) {
    const request = new UnsubscriptionRequestDTO(form["email"]);

    setApiResponse(
      <span className="ml-3 text-danger font-weight-bold">{"Waiting..."}</span>
    );
    enablementAction
      .unsubscribe(request)
      .then((response) => {
        response.data.isSuccess === true
          ? setApiResponse(
              <span className="ml-3 text-danger font-weight-bold">
                {"Unsubscription done"}
              </span>
            )
          : setApiResponse(
              <span className="ml-3 text-danger font-weight-bold">
                {"Something went wrong. Try again later."}
              </span>
            );
      })
      .catch((err) => {
        console.error("subscription failed", err);
        setApiResponse(
          <span className="ml-3 text-danger font-weight-bold">
            {"Something went wrong. Try again later."}
          </span>
        );
      });
  }

  async function getAllEvents() {
    enablementAction
      .getAllEvents()
      .then((response) => {
        console.log(response.data);
        let events = Array<{ title; start; end; link; region; type }>();
        const clusters: Array<EventCLusterDTO> = response.data;
        for (const c of clusters) {
          for (const e of c.events) {
            events.push({
              title: e.description,
              start: e.newDate,
              end: e.newDate,
              link: c.redirectUrl,
              region: e.type?.region,
              type: e.type?.name,
            });
          }
        }
        setEventsData(events);
        setEventsDataAll(events);
        return events;
      })
      .catch((err) => {
        console.error("events were not catch. Error: ", err);
      });
  }

  function closeForm() {
    let temp = form;
    temp["REGIONS"] = [];
    temp["TRAINING"] = [];
    setForm(temp);
    setApiResponse(<span></span>);
    setHasSubmitted(false);
    setShow(false);
    setShowUns(false);
  }

  function onChangeForm(e) {
    const name = e.target.name;
    const value = e.target.value;
    setForm({ ...form, [name]: value });
  }

  function onChangeCheckForm(e) {
    const fieldName = e.target.name;
    let temp = form[fieldName] || [];
    const isChecked = e.target.checked;
    const valueField = e.target.value;

    if (isChecked) {
      temp.push(valueField);
    } else {
      let index = temp.indexOf(valueField);
      temp.splice(index, 1);
    }

    setForm({ ...form, [fieldName]: temp });
  }

  function canYouHaveAccess() {
    try {
      if (
        process.env.REACT_APP_PROTECT_PAGE === "true" &&
        window.top?.location.host !== process.env.REACT_APP_ALLOW_API
      ) {
        console.log("You shall not pass");
        history.push("/not-found");
      }
    } catch (err) {}
  }
}

export default CalendarBlock;
